<template>
  <div class="page">
    <project-page-header show-steps ref="pageHeader" :id="projectId">
      <template v-slot:actions="{ data }">
        <a-space>
          <template v-if="data.state === 2">
            <a-button class="v-px-sm" type="indigo" icon="arrow-left" @click="handleBackword">退回至上一步</a-button>
          </template>
          <a-button size="default" class="v-px-sm" type="default" icon="left" @click="$router.push(`/project/main/school/view?id=${data.pid}`)" v-if="data.pid">返回主项目</a-button>
        </a-space>
      </template>
    </project-page-header>
    <div class="v-px-md">
      <a-tabs type="card" v-model="tab">
        <a-tab-pane key="basic" tab="项目信息">
          <div class="v-px-sm v-py-sm"><basic /></div>
        </a-tab-pane>
        <a-tab-pane key="meeting" tab="评审会议">
          <div class="v-px-sm v-py-sm"><meeting /></div>
        </a-tab-pane>
        <a-tab-pane key="contract" tab="上传项目协议">
          <div class="panel v-mt-lg v-pa-md w1000">
            <h3 class="text-center v-mb-md">上传项目协议</h3>
            <div class="panel-body">
              <a-form-model ref="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }" class="form-class">
                <a-form-model-item :colon="false">
                  <span slot="label">
                    <i class="required-mark">*</i>
                    实施周期
                  </span>
                  <a-range-picker v-model="dates" format="YYYY-MM-DD" value-format="YYYY-MM-DD" :placeholder="['开始日期', '结束日期']" ref="datePicker" style="width: 210px" />
                </a-form-model-item>
                <a-form-model-item :colon="false">
                  <span slot="label">
                    <i class="required-mark">*</i>
                    上传项目协议
                  </span>
                  <a-upload-dragger
                    :action="`${baseURL}/file/upload`"
                    :data="{
                      params: JSON.stringify({ projectId, fileBelongId: projectId, fileType: 8, fileSign: 'P01' }),
                    }"
                    :show-upload-list="{
                      showPreviewIcon: true,
                      showRemoveIcon: true,
                      showDownloadIcon: true,
                    }"
                    :file-list="files"
                    :before-upload="beforeUploadFile"
                    @preview="handlePreviewFile"
                    @change="info => handleUploadChange(info, -1, 'files')"
                    @download="({ fileId, name }) => downloadFile({ fileId, belongId: projectId, fileSign: 'P01', fileName: name })"
                    accept=".pdf, .doc, .docx"
                    ref="files"
                  >
                    <div class="v-pa-xs">
                      <a-icon type="plus" />
                      <p class="font-xs">点击或拖拽文件至此区域上传</p>
                    </div>
                  </a-upload-dragger>
                </a-form-model-item>
              </a-form-model>
            </div>
          </div>
          <div class="text-center v-mt-lg" v-if="currentStep == 2">
            <a-space class="v-ml-auto">
              <a-button icon="check" type="indigo" @click="handleConfirm(false)" :loading="saving">保存初稿</a-button>
              <a-button icon="arrow-right" type="primary" @click="handleConfirm(true)" :loading="saving">提交，下一步项目执行</a-button>
              <a-button icon="left" type="default" @click="$router.go(-1)">返回</a-button>
            </a-space>
          </div>
        </a-tab-pane>
      </a-tabs>
    </div>
  </div>
</template>

<script>
import ProjectPageHeader from './common/page-header'
import { viewPrj, saveProtocol, backwardPrj } from '@/api/project/school'
import { geFilesBytProjectType } from '@/api/file'
import Basic from './view/basic'
import Meeting from './view/meeting'

export default {
  name: 'FundedProjectView',
  components: {
    Basic,
    Meeting,
    ProjectPageHeader,
  },
  data() {
    return {
      tab: 'contract',
      projectId: +this.$route.query.id,
      dates: [],
      files: [],
      currentStep: 0,
      saving: false,
    }
  },
  watch: {
    tab(val) {
      if (val == 'contract') {
        this.load()
      }
    }
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.load()
        this.loadFiles()
      }
    },
    load() {
      let id = this.projectId
      viewPrj(id).then(({ data }) => {
        if (data.success) {
          this.data = data.result
          let { state, startDate, endDate } = data.result
          this.currentStep = state
          if (startDate && endDate) {
            this.dates = [startDate, endDate]
          }
        }
      })
    },
    loadFiles() {
      geFilesBytProjectType(this.projectId, 8).then(({ data }) => {
        if (data.success) {
          this.files = data.result.map(file => ({
            uid: file.fileId,
            name: file.fileOriginName,
            status: 'done',
            fileSign: 'P01',
            belongId: file.raiseId,
            ...file,
            url: `${this.baseURL}/file/view?id=${file.fileId}&belongId=${file.projectId}&fileSign=P01`,
          }))
        }
      })
    },
    handleUploadChange(info, count, ref) {
      if (ref && this.$refs[ref]) {
        this[ref] = this.handleUploadFile(info, count)
        this.$refs[ref].$el.classList.remove('uploader-empty')
      }
    },
    handleConfirm(nextStep) {
      let { dates, files } = this
      this.$message.destroy()
      if (dates.length == 0) {
        this.$message.warn('请选择实施周期')
        this.$refs.datePicker.focus()
        return
      }
      if (files.length == 0) {
        this.$message.warn('上传项目协议')
        this.$refs.files.$el.classList.add('uploader-empty')
        return
      }
      this.$confirm({
        title: nextStep ? '确认进入下一步？' : '确认保存草稿？',
        centered: true,
        onOk: () => {
          this.handleSubmit(nextStep)
        },
      })
    },
    handleSubmit(nextStep) {
      let {
        dates: [startDate, endDate],
        files,
        projectId,
      } = this
      let params = {
        id: projectId,
        startDate: `${startDate} 00:00`,
        endDate: `${endDate} 00:00`,
        fileIds: files.map(file => file.fileId),
        nextStep,
      }
      saveProtocol(params).then(({ data }) => {
        this.saving = false
        if (data.success) {
          this.$message.success('操作成功')
          if (nextStep) {
            this.$router.push(`view?id=${projectId}`)
          }
        } else {
          this.$message.warn('操作失败')
        }
      })
    },
    handleBackword() {
      let { projectId } = this
      this.$confirm({
        title: '确认退回至上一步？',
        centered: true,
        onOk: () => {
          return new Promise((resolve, reject) => {
            backwardPrj(projectId).then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.$router.push(`review?id=${projectId}`)
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
            })
          }).catch(() => this.$message.warn('操作失败'))
        },
      })
    },
  },
  created() {
    this.init()
  },
}
</script>
